import { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface FunctionTileProps {
  title: string;
  description: string;
  icon: LucideIcon;
  onClick: () => void;
  className?: string;
}

const FunctionTile = ({ 
  title, 
  description, 
  icon: Icon, 
  onClick, 
  className
}: FunctionTileProps) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        "group relative overflow-hidden rounded-lg p-6 text-left transition-all duration-200",
        "shadow-sm hover:shadow-md hover:-translate-y-0.5",
        "active:translate-y-0 focus:outline-none focus:ring-2",
        className
      )}
      style={{ 
        backgroundColor: '#fbf8f4',
        border: '1px solid #efe7dd',
        '--focus-ring-color': '#d9cbbf'
      }}
    >
      <div className="flex items-start gap-4">
        {/* Icon Container */}
        <div 
          className="flex-shrink-0 p-3 rounded-lg transition-colors duration-200"
          style={{ backgroundColor: '#efe7dd' }}
        >
          <Icon className="h-6 w-6 transition-colors" style={{ color: '#a0897c' }} />
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-semibold mb-2 transition-colors" style={{ color: '#837069' }}>
            {title}
          </h3>

          <p className="text-sm leading-relaxed transition-colors" style={{ color: '#b6a092' }}>
            {description}
          </p>
        </div>
      </div>
    </button>
  );
};

export default FunctionTile;